import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid pb-4"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "text-xs text-secondary mb-0" }
const _hoisted_4 = { class: "text-dark font-weight-bold" }
const _hoisted_5 = { class: "mb-0 mt-1" }
const _hoisted_6 = { class: "row align-items-start" }
const _hoisted_7 = { class: "col-lg-7 mb-4" }
const _hoisted_8 = { class: "card h-100" }
const _hoisted_9 = { class: "card-header d-flex align-items-center gap-2" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "card-body pt-3" }
const _hoisted_12 = { class: "d-flex flex-column align-items-center mb-4" }
const _hoisted_13 = { class: "vehicle-photo-box position-relative" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "fa-solid fa-car-side vehicle-photo-box__placeholder"
}
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "form-check form-switch mt-3 mb-0" }
const _hoisted_18 = ["checked", "disabled"]
const _hoisted_19 = {
  class: "form-check-label",
  for: "vehicleEnabled"
}
const _hoisted_20 = {
  key: 0,
  class: "text-muted text-center mt-1"
}
const _hoisted_21 = { class: "row g-3" }
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "form-control-label" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "form-control-label" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "form-control-label" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "form-control-label" }
const _hoisted_33 = { class: "d-flex gap-2" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { class: "form-control-label" }
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = { class: "form-control-label" }
const _hoisted_39 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "fas fa-circle-notch fa-spin me-1"
}
const _hoisted_42 = { class: "col-lg-5 mb-4" }
const _hoisted_43 = { class: "card h-100" }
const _hoisted_44 = { class: "card-header d-flex align-items-center gap-2" }
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = { class: "vehicle-count-pill ms-auto" }
const _hoisted_47 = {
  key: 0,
  class: "text-center text-secondary py-5"
}
const _hoisted_48 = { class: "text-sm mb-0" }
const _hoisted_49 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_50 = { class: "table align-items-center mb-0" }
const _hoisted_51 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_52 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder text-end" }
const _hoisted_53 = { class: "py-1" }
const _hoisted_54 = { class: "d-flex align-items-center gap-2" }
const _hoisted_55 = { class: "vehicle-driver-avatar" }
const _hoisted_56 = { class: "text-xs font-weight-bold mb-0" }
const _hoisted_57 = { class: "align-middle text-end" }
const _hoisted_58 = { class: "form-check form-switch mb-0 d-inline-block" }
const _hoisted_59 = ["checked", "disabled", "onChange"]
const _hoisted_60 = { class: "vehicle-info-strip" }
const _hoisted_61 = {
  class: "modal fade",
  id: "vehicle-disable-modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_62 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = { class: "modal-header" }
const _hoisted_65 = { class: "modal-title" }
const _hoisted_66 = { class: "modal-body" }
const _hoisted_67 = { class: "modal-footer" }
const _hoisted_68 = {
  key: 1,
  class: "text-center py-5"
}

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Modal } from 'bootstrap'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import VehicleRepository from '@/repositories/VehicleRepository'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'
import { Vehicle } from '@/types/Vehicle'
import ImageLoader from '@/components/ImageLoader.vue'
import StorageService from '@/services/StorageService'
import DateHelper from '@/helpers/DateHelper'
import { useSelectableToggle } from '@/composables/useSelectableToggle'

const vehicleEvent = 'vehicle-image-loaded'

// Pending disable state when a confirmation modal is needed
interface ExpiryHint {
  text: string
  cls: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Edit',
  setup(__props) {

dayjs.extend(utc)

const route = useRoute()
const router = useRouter()

const vehicle = ref<Vehicle | null>(null)
const saving = ref<boolean>(false)
const { togglingDriverId, toggle } = useSelectableToggle()

// Form reactive state
const form = ref({
  brand: '' as string | null,
  model: '' as string | null,
  photoUrl: '' as string | null,
  soat_exp: '' as string | null,
  tec_exp: '' as string | null,
  enabled: true,
})

const colorName = ref<string>('')
const colorHex = ref<string>('#000000')

const vehiclePath = StorageService.vehiclePath
let disableModalInstance: Modal | null = null
let pendingDisableConfirmed = false

onMounted(async () => {
  const id = route.params.id as string
  try {
    vehicle.value = await VehicleRepository.findById(id)
    if (vehicle.value) {
      form.value.brand = vehicle.value.brand
      form.value.model = vehicle.value.model
      form.value.photoUrl = vehicle.value.photoUrl
      form.value.soat_exp = DateHelper.normalizeDateInput(vehicle.value.soat_exp)
      form.value.tec_exp = DateHelper.normalizeDateInput(vehicle.value.tec_exp)
      form.value.enabled = vehicle.value.enabled
      colorName.value = vehicle.value.color?.name ?? ''
      colorHex.value = vehicle.value.color?.hex ?? '#000000'
    }
  } catch (e: unknown) {
    const err = e as { message?: string }
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), err?.message)
  }
})

function onToggle(driverId: string, newValue: boolean): Promise<void> {
  return toggle(vehicle.value, driverId, newValue)
}

function initials(name: string): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '?'
  return parts.slice(0, 2).map(w => w[0]).join('').toUpperCase()
}

function expiryHint(dateStr: string | null): ExpiryHint | null {
  const normalized = DateHelper.normalizeDateInput(dateStr)
  if (!normalized) return null

  const diff = dayjs.utc(normalized).startOf('day').diff(dayjs.utc().startOf('day'), 'day')
  if (diff < 0) {
    return { text: i18n.global.t('vehicles.expiry.expired'), cls: 'text-danger' }
  }
  if (diff < 30) {
    // Named values must precede the plural count for vue-i18n to interpolate {n} correctly
    // (mirrors the pattern used for `drivers.detail.count_movements`).
    return { text: i18n.global.t('vehicles.expiry.expires_in', { n: diff }, diff), cls: 'text-warning' }
  }
  return { text: i18n.global.t('vehicles.expiry.valid'), cls: 'text-success' }
}

const soatHint = computed<ExpiryHint | null>(() => expiryHint(form.value.soat_exp))
const tecHint = computed<ExpiryHint | null>(() => expiryHint(form.value.tec_exp))

function goBack(): void {
  router.back()
}

function onVehicleImageLoaded(url: string): void {
  form.value.photoUrl = url
  if (vehicle.value) {
    vehicle.value.photoUrl = url
  }
}

function normalizeVehicleDateForPayload(value: string | null): string | null {
  const normalized = DateHelper.normalizeDateInput(value)
  return normalized || null
}

const colorObject = computed(() => ({
  name: colorName.value,
  hex: colorHex.value,
}))

const isComplete = computed<boolean>(() => {
  return !!(
    form.value.brand?.trim() &&
    form.value.model?.trim() &&
    colorName.value?.trim() &&
    form.value.soat_exp &&
    form.value.tec_exp
  )
})

const missingFields = computed<string[]>(() => {
  const fields: string[] = []
  if (!form.value.brand?.trim()) fields.push(i18n.global.t('drivers.vehicle.brand'))
  if (!form.value.model?.trim()) fields.push(i18n.global.t('drivers.vehicle.model'))
  if (!colorName.value?.trim()) fields.push(i18n.global.t('drivers.placeholders.color'))
  if (!form.value.soat_exp) fields.push(i18n.global.t('vehicles.fields.soat_exp'))
  if (!form.value.tec_exp) fields.push(i18n.global.t('vehicles.fields.tec_exp'))
  return fields
})

async function onEnabledChange(event: Event): Promise<void> {
  const target = event.target as HTMLInputElement
  const newEnabled = target.checked

  if (newEnabled && !isComplete.value) {
    // Block enabling — vehicle is incomplete
    target.checked = false
    form.value.enabled = false
    ToastService.toast(
      ToastService.ERROR,
      i18n.global.t('common.messages.error'),
      i18n.global.t('vehicles.messages.cannot_enable_incomplete', { fields: missingFields.value.join(', ') }),
    )
    return
  }

  if (!newEnabled && vehicle.value?.currently_driven_by) {
    // Revert the toggle — user must confirm via modal
    target.checked = true
    form.value.enabled = true

    pendingDisableConfirmed = false
    const el = document.getElementById('vehicle-disable-modal')
    if (el) {
      disableModalInstance = Modal.getOrCreateInstance(el)
      disableModalInstance.show()
    }
    return
  }

  form.value.enabled = newEnabled
}

function cancelDisable(): void {
  pendingDisableConfirmed = false
  disableModalInstance?.hide()
}

async function confirmDisable(): Promise<void> {
  pendingDisableConfirmed = true
  disableModalInstance?.hide()

  if (!vehicle.value) return
  try {
    await VehicleRepository.setEnabled(vehicle.value.id, false, true)
    form.value.enabled = false
    vehicle.value.enabled = false
    ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  } catch (e: unknown) {
    const err = e as { message?: string }
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), err?.message)
  }
}

async function save(): Promise<void> {
  if (!vehicle.value) return

  if (!form.value.brand?.trim()) {
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), i18n.global.t('vehicles.validations.brand_required'))
    return
  }
  if (!form.value.model?.trim()) {
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), i18n.global.t('vehicles.validations.model_required'))
    return
  }
  if (!colorName.value?.trim()) {
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), i18n.global.t('vehicles.validations.color_required'))
    return
  }

  saving.value = true
  try {
    const payload: Partial<Vehicle> = {
      brand: form.value.brand,
      model: form.value.model,
      photoUrl: form.value.photoUrl?.trim() || null,
      soat_exp: normalizeVehicleDateForPayload(form.value.soat_exp),
      tec_exp: normalizeVehicleDateForPayload(form.value.tec_exp),
      color: colorObject.value,
    }

    const previousEnabled = vehicle.value.enabled
    const updatedVehicle = await VehicleRepository.update(vehicle.value.id, payload)
    vehicle.value = {
      ...vehicle.value,
      ...updatedVehicle,
      enabled: previousEnabled,
    }

    // If enabled state changed (and not a force-disconnect case already handled)
    if (form.value.enabled !== previousEnabled && !pendingDisableConfirmed) {
      if (form.value.enabled && !isComplete.value) {
        ToastService.toast(
          ToastService.ERROR,
          i18n.global.t('common.messages.error'),
          i18n.global.t('vehicles.messages.cannot_enable_incomplete', { fields: missingFields.value.join(', ') }),
        )
        return
      }
      try {
        await VehicleRepository.setEnabled(vehicle.value.id, form.value.enabled)
      } catch (e: unknown) {
        const axiosErr = e as { response?: { data?: { error?: string; missing_fields?: string[] } } }
        if (axiosErr.response?.data?.error === 'vehicle_incomplete') {
          const serverMissing = axiosErr.response.data.missing_fields ?? missingFields.value
          ToastService.toast(
            ToastService.ERROR,
            i18n.global.t('common.messages.error'),
            i18n.global.t('vehicles.messages.cannot_enable_incomplete', { fields: serverMissing.join(', ') }),
          )
          return
        }
        throw e
      }

      vehicle.value.enabled = form.value.enabled
    }
    ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
    router.push({ name: 'vehicles.detail', params: { id: vehicle.value.id } })
  } catch (e: unknown) {
    const err = e as { message?: string }
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), err?.message)
  } finally {
    saving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (vehicle.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t('routes.vehicles')) + " ", 1),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mx-1" }, "/", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(vehicle.value.plate), 1)
            ]),
            _createElementVNode("h6", _hoisted_5, _toDisplayString(vehicle.value.brand) + " " + _toDisplayString(vehicle.value.model), 1)
          ]),
          _createElementVNode("button", {
            onClick: goBack,
            class: "btn btn-sm btn-info"
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("em", { class: "fas fa-arrow-left me-1" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.back')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "icon icon-shape icon-sm bg-gradient-primary shadow text-center border-radius-md d-flex align-items-center justify-content-center" }, [
                  _createElementVNode("em", { class: "fas fa-car-side text-white text-xs" })
                ], -1)),
                _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.$t('vehicles.forms.edit')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (vehicle.value.photoUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: vehicle.value.photoUrl,
                          class: "vehicle-photo-box__img",
                          alt: "Vehicle photo"
                        }, null, 8, _hoisted_14))
                      : (_openBlock(), _createElementBlock("em", _hoisted_15)),
                    _createElementVNode("button", {
                      class: "vehicle-photo-box__edit-btn",
                      type: "button",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#image-vehicle",
                      title: _ctx.$t('common.actions.edit')
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                    ]))], 8, _hoisted_16)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "vehicleEnabled",
                      checked: form.value.enabled,
                      disabled: !isComplete.value && !form.value.enabled,
                      onChange: onEnabledChange
                    }, null, 40, _hoisted_18),
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t(form.value.enabled ? 'common.fields.enabled' : 'common.fields.disabled')), 1)
                  ]),
                  (!isComplete.value)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.$t('vehicles.messages.cannot_enable_incomplete', { fields: missingFields.value.join(', ') })), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('drivers.fields.plate')), 1),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      value: vehicle.value.plate,
                      disabled: ""
                    }, null, 8, _hoisted_24)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('drivers.vehicle.brand')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.brand) = $event)),
                      placeholder: _ctx.$t('drivers.placeholders.brand')
                    }, null, 8, _hoisted_27), [
                      [_vModelText, form.value.brand]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('drivers.vehicle.model')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.model) = $event)),
                      placeholder: _ctx.$t('drivers.vehicle.model')
                    }, null, 8, _hoisted_30), [
                      [_vModelText, form.value.model]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('drivers.placeholders.color')), 1),
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((colorName).value = $event)),
                        placeholder: _ctx.$t('drivers.placeholders.color')
                      }, null, 8, _hoisted_34), [
                        [_vModelText, colorName.value]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "color",
                        class: "form-control form-control-sm p-0 vehicle-color-swatch",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((colorHex).value = $event))
                      }, null, 512), [
                        [_vModelText, colorHex.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('drivers.vehicle.soat_exp')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.soat_exp) = $event))
                    }, null, 512), [
                      [_vModelText, form.value.soat_exp]
                    ]),
                    (soatHint.value)
                      ? (_openBlock(), _createElementBlock("small", {
                          key: 0,
                          class: _normalizeClass(["d-block fw-bold mt-1", soatHint.value.cls])
                        }, _toDisplayString(soatHint.value.text), 3))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('drivers.vehicle.tec_exp')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.tec_exp) = $event))
                    }, null, 512), [
                      [_vModelText, form.value.tec_exp]
                    ]),
                    (tecHint.value)
                      ? (_openBlock(), _createElementBlock("small", {
                          key: 0,
                          class: _normalizeClass(["d-block fw-bold mt-1", tecHint.value.cls])
                        }, _toDisplayString(tecHint.value.text), 3))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    class: "btn btn-info btn-sm mb-0",
                    onClick: save,
                    disabled: saving.value
                  }, [
                    (saving.value)
                      ? (_openBlock(), _createElementBlock("em", _hoisted_41))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                  ], 8, _hoisted_40)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "icon icon-shape icon-sm bg-gradient-success shadow text-center border-radius-md d-flex align-items-center justify-content-center" }, [
                  _createElementVNode("em", { class: "fas fa-users text-white text-xs" })
                ], -1)),
                _createElementVNode("h6", _hoisted_45, _toDisplayString(_ctx.$t('vehicles.fields.linked_drivers')), 1),
                _createElementVNode("span", _hoisted_46, _toDisplayString(vehicle.value.linked_drivers?.length ?? 0), 1)
              ]),
              (!vehicle.value.linked_drivers || vehicle.value.linked_drivers.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _cache[11] || (_cache[11] = _createElementVNode("em", { class: "fa-solid fa-users-slash fa-2x mb-2 d-block opacity-25" }, null, -1)),
                    _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('vehicles.messages.no_linked_drivers')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("table", _hoisted_50, [
                      _cache[12] || (_cache[12] = _createElementVNode("caption", { hidden: "" }, null, -1)),
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.$t('common.fields.name')), 1),
                          _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.$t('vehicles.fields.selectable')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehicle.value.linked_drivers, (entry) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: entry.driver_id
                          }, [
                            _createElementVNode("td", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("span", _hoisted_55, _toDisplayString(initials(entry.driver_name)), 1),
                                _createElementVNode("p", _hoisted_56, _toDisplayString(entry.driver_name), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  role: "switch",
                                  checked: entry.selectable,
                                  disabled: _unref(togglingDriverId) === entry.driver_id,
                                  onChange: ($event: any) => (onToggle(entry.driver_id, !entry.selectable))
                                }, null, 40, _hoisted_59)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])),
              _createElementVNode("div", _hoisted_60, [
                _cache[15] || (_cache[15] = _createElementVNode("em", { class: "fas fa-circle-info" }, null, -1)),
                _createElementVNode("span", null, [
                  _cache[13] || (_cache[13] = _createTextVNode(" Activa ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('vehicles.fields.selectable')), 1),
                  _cache[14] || (_cache[14] = _createTextVNode(" para que el conductor pueda usar este vehículo al aceptar servicios. Solo un conductor puede tener el vehículo activo a la vez. ", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("h5", _hoisted_65, _toDisplayString(_ctx.$t('vehicles.messages.disable_confirm_title')), 1),
                _cache[16] || (_cache[16] = _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('vehicles.messages.disable_confirm_body', { name: vehicle.value.currently_driven_by?.name ?? '' })), 1)
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: cancelDisable
                }, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: confirmDisable
                }, _toDisplayString(_ctx.$t('vehicles.actions.force_disconnect')), 1)
              ])
            ])
          ])
        ]),
        _createVNode(ImageLoader, {
          id: 'image-vehicle',
          resourceId: vehicle.value.id,
          path: _unref(vehiclePath),
          event: vehicleEvent,
          onVehicleImageLoaded: onVehicleImageLoaded
        }, null, 8, ["resourceId", "path"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_68, [...(_cache[17] || (_cache[17] = [
        _createElementVNode("em", { class: "fas fa-circle-notch fa-spin fa-2x text-secondary" }, null, -1)
      ]))]))
}
}

})